// extracted by mini-css-extract-plugin
module.exports = {"instagramEmbedWrapper":"InstagramEmbed_instagramEmbedWrapper__C_IME","iFrameContainerInstagram":"InstagramEmbed_iFrameContainerInstagram__kZ9fg"};